import { render, staticRenderFns } from "./WhereBuy.vue?vue&type=template&id=7a264822&scoped=true&"
import script from "./WhereBuy.vue?vue&type=script&lang=js&"
export * from "./WhereBuy.vue?vue&type=script&lang=js&"
import style0 from "./WhereBuy.vue?vue&type=style&index=0&id=7a264822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a264822",
  null
  
)

export default component.exports